import React, { Component } from 'react';
import { ContactBanner } from 'views/contact/subcomponents';
import { enableAnimations } from 'config/helpers';
import { SesSection } from 'components/SeS';

import { Banner, ListOfServices, Technologies } from './subcomponents';
import './Services.scss';

class Services extends Component {
  componentDidMount() {
    enableAnimations();
  }

  render() {
    return (
      <div
        id={'services-page'}
        className={'single-page single-page--hero services'}
      >
        <Banner link={'services-list'} />
        <ListOfServices />
        <SesSection />
        <Technologies />
        <ContactBanner
          dataPdWebforms={
            'https://webforms.pipedrive.com/f/cs9dOxJOmE5gaVtA984VfwEuPoJdBsZgEEtvPiKgr6U3hcEK0dU8ApHM9rhP1RzZtx'
          }
        />
      </div>
    );
  }
}

export default Services;
